// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"LoginScreen_loginForm__2Jx0s"};